import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_URL_TOKEN, SearchCriteria, User, UserBranchRoles } from '@raptor-fe/core';
import { Observable, of } from 'rxjs';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    protected http = inject(HttpClient);
    protected baseUrl = inject(BASE_URL_TOKEN);
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    get(tenantId: string, id: string, showLoading = true): Observable<User | null> {
        if (id === null || id === undefined || id === '')
            return of({
                tenantId: tenantId,
                id: id,
            } as User);
        else
            return this.http.get<User>(`${this.baseUrl}v1/tenant/${tenantId}/user/${id}`, {
                headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
            });
    }

    getAll(tenantId: string, includeRoles = false, branchRolesId: string | null = null): Observable<User[]> {
        return this.http.get<User[]>(
            `${this.baseUrl}v1/tenant/${tenantId}/user${includeRoles ? `?includeRoles=true&branchRolesId=${branchRolesId}` : ''}`,
        );
    }

    getBranchesRoles(tenantId: string, userId: string): Observable<UserBranchRoles[]> {
        if (userId === null || userId === undefined || userId === '') return of([]);

        return this.http.get<UserBranchRoles[]>(`${this.baseUrl}v1/tenant/${tenantId}/user/branches-roles/${userId}`);
    }

    getBranchesRolesByUsername(tenantId: string, username: string): Observable<UserBranchRoles[]> {
        if (username === null || username === undefined || username === '') return of([]);

        return this.http.get<UserBranchRoles[]>(`${this.baseUrl}v1/tenant/${tenantId}/user/branches-roles/username/${username}`);
    }

    delete(tenantId: string, id: string): Observable<object> {
        return this.http.delete<object>(`${this.baseUrl}v1/tenant/${tenantId}/user/${id}`);
    }

    save(user: User, isNew: boolean): Observable<User> {
        const url = `${this.baseUrl}v1/tenant/${user.tenantId}/user`;

        if (isNew) {
            return this.http.post<User>(url, user);
        } else {
            return this.http.put<User>(url, user);
        }
    }

    search(tenantId: string, criteria: SearchCriteria, branchRolesId: string | null = null, showLoading = true): Observable<User[]> {
        return this.http.post<User[]>(
            `${this.baseUrl}v1/tenant/${tenantId}/user/search${branchRolesId ? `?branchRolesId=${branchRolesId}` : ''}`,
            criteria,
            {
                headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
            },
        );
    }

    setUserBranchId(tenantId: string, branchId: string): Observable<object> {
        return this.http.put(`${this.baseUrl}v1/tenant/${tenantId}/user/branch/${branchId}`, {});
    }
}
